// src/api.js
import axios from 'axios';

const apiClient = axios.create({
    //  baseURL: 'http://localhost/',
     baseURL: 'https://api.axiondmc.com/',
    // baseURL: 'https://df.rivieragrouptravel.com/',
   // baseURL: 'http://188.169.95.96/',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
});

apiClient.interceptors.request.use(config => {
    // Добавляем JWT, если есть
    const token = localStorage.getItem('jwt');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    // Для POST-запросов: в тело добавляем поле language
    const lang = localStorage.getItem('lang');
    if (lang && config.method && config.method.toLowerCase() === 'post') {
        config.data = config.data || {};
        config.data.language = lang;
    }

    return config;
});

export default apiClient;
